<template>
  <div>
    <Logo></Logo>
    <h2 class="shareholder-hd">관계사 프로모션 혜택 인증</h2>
    <p class="shareholder-explain">
      <span>관계사 프로모션 혜택 적용을 원하시는</span>
      <span>Wavve 계정에 로그인해 주세요.</span>
    </p>
    <template v-if="isSupportBrowser">
      <div class="input-wrap">
        <input type="text" id="id" placeholder="이메일 주소 또는 아이디" autocomplete="off" v-model="id">
        <p class="noti-purple" v-if="isEmptyIdOrPassword && id ==='' ">
          <span class="join-noti-ico"><InfoPurple /></span>
          <span class="join-noti-text">이메일 또는 아이디를 입력해주세요.</span>
        </p>
      </div>
      <div class="input-wrap">
        <input :type="hidePassword ? 'password' : 'text'" id="pw" placeholder="비밀번호" v-model="password"
               autocomplete="off"
               ref="login"
               @keyup.enter="generalLogin">
        <p class="noti-purple" v-if="isEmptyIdOrPassword && password ==='' && id !== ''">
          <span class="join-noti-ico"><InfoPurple /></span>
          <span class="join-noti-text">비밀번호를 입력해주세요.</span>
        </p>
        <button class="input-btn" type="button" @click.stop="togglePasswordInputType">{{hidePassword ? 'show' : 'hide'}}</button>
      </div>
      <button type="button" class="login" @click.prevent="generalLogin">로그인</button>
    </template>
    <div class="login-help">
      <p class="shareholder-explain">
        <span> 회원가입 또는 SNS 회원 가입은 Wavve 홈에서 진행하신 다음 혜택 인증 페이지로 재접속하시어 로그인해 주세요. </span>
        <span> <a href="https://www.wavve.com">[Wavve 홈 가기]</a></span>
      </p>
    </div>
    <div class="login-sns" v-if="isSupportBrowser">
      <div class="login-line-box">
        <span>또는 다른 서비스 계정으로 로그인</span>
      </div>
      <ul>
        <li class="login-sns-each kakao">
          <a href="#" @click.prevent="kakaoLogin">
            <span class="sns-center">
                <span class="icon-sns icon-kakao"></span>
                <span class="txt-sns">카카오로 시작하기</span>
            </span>
          </a>
        </li>
        <li class="login-sns-each tworld">
          <div>
            <a href="#" @click.prevent="tLogin">
              <span class="sns-center">
                  <span class="icon-sns icon-tworld"></span>
                  <span class="txt-sns">T아이디로 시작하기</span>
              </span>
            </a>
          </div>
        </li>
        <li class="login-sns-each naver">
          <div>
            <a href="#" @click.prevent="naverLogin">
              <span class="sns-center">
                  <span class="icon-sns icon-naver"></span>
                  <span class="txt-sns">네이버로 시작하기</span>
              </span>
            </a>
            <div v-show="false" id="naverIdLogin"></div>
          </div>
        </li>
        <li class="login-sns-each facebook">
          <a href="#" @click.prevent="facebookLogin">
            <span class="sns-center">
                <span class="icon-sns icon-facebook"></span>
                <span class="txt-sns">페이스북으로 시작하기</span>
            </span>
          </a>
        </li>
        <li class="login-sns-each apple">
          <div>
            <a href="#" @click.prevent="appleLogin">
              <span class="sns-center">
                  <span class="icon-sns icon-apple"></span>
                  <span class="txt-sns">Apple 아이디로 시작하기</span>
              </span>
            </a>
          </div>
        </li>
      </ul>
    </div>
    <div class="sns-exclamation">
      <p>
        <span>관계사 할인 프로모션 이메일 인증은 1개의 Wavve 계정에만 가능합니다.</span>
        <span>한번 인증이 완료되면 다른 Wavve 계정으로는 중복 인증 및 인증 계정 변경은 불가능하니 신중히 로그인해 주세요.</span>
      </p>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-undef */
/* eslint-disable no-script-url */
import { get, trim } from 'lodash'
import Logo from '@/views/partners/Logo'
import InfoPurple from '@/assets/svg/common/ic-info-p.svg'
import utils from '@/common/util/utils'
import { PartnersService, UserService } from '@/common/api/api.service'
import { setLibFile } from '@/common/plugins/sns.lib'
import { URL_COOKIE_DOMAIN } from '@/common/constant'
import { isIE } from '@/common/util/ua'
import { PATH_NAME_VOUCHER } from '@/common/router.const'

export default {
  name: 'Login',
  components: {
    Logo,
    InfoPurple
  },
  data () {
    return {
      hidePassword: true,
      isEmptyIdOrPassword: false,
      id: '',
      password: '',
      naverLoginLib: null
    }
  },
  methods: {
    setReferer () {
      utils.cookies.removeItem('need-pp-token', URL_COOKIE_DOMAIN, '/')
      utils.cookies.setItem('need-pp-token', 'true', null, URL_COOKIE_DOMAIN, '/')
    },
    generalLogin () {
      const isEmptyString = str => trim(str).length === 0
      if (isEmptyString(this.id) || isEmptyString(this.password)) {
        this.$nextTick(() => {
          this.isEmptyIdOrPassword = true
        })
      }
      this.loginProc({
        type: 'general',
        id: this.id,
        password: this.password
      })
    },
    tLoginProc (idToken) {
      this.loginProc({
        type: 'tid',
        id: idToken
      })
    },
    appleLoginProc (idToken) {
      this.loginProc({
        type: 'apple',
        id: idToken
      })
    },
    kakaoLogin () {
      const self = this
      Kakao.Auth.login({
        success: function () {
          self.loginProc({
            type: 'kakao',
            id: Kakao.Auth.getAccessToken()
          })
        },
        fail: function (err) {
          console.log('FAILED LOGIN KAKAO', err)
        }
      })
    },
    tLogin () {
      UserService.getSktToken({ promotionCode: 'forholder' }).then((response) => {
        this.setReferer()
        location.replace(get(response, ['data', 'weburl'], ''))
      })
    },
    naverLogin () {
      const loginEl = document.getElementById('naverIdLogin_loginButton')
      if (loginEl) {
        loginEl.setAttribute('href', 'javascript:;')
        // eslint-disable-next-line
        if (/* @cc_on ! @ */ false) {
          // eslint-disable-next-line
          loginEl.fireEvent('onclick')
        } else {
          // Others
          let event = document.createEvent('MouseEvents')
          event.initEvent('click', false, true)
          loginEl.dispatchEvent(event)
        }
      }
    },
    facebookLogin () {
      const self = this
      FB.getLoginStatus(function (statusResponse) {
        // 이미 로그인 상태일 때
        if (statusResponse.status === 'connected') {
          self.loginProc({ type: 'facebook', id: statusResponse.authResponse.accessToken })
        } else {
          // 페이스북 로그인 안돼있는 상태일 때 페이스북 로그인 처리
          FB.login(function (facebookLoginResponse) {
            // 로그인에 성공했을 때 로그인 처리
            if (facebookLoginResponse.status === 'connected') {
              self.loginProc({ type: 'facebook', id: facebookLoginResponse.authResponse.accessToken })
            }
            // public_profile,email : 이메일 주소와 친구의 목록에 접근하는 권한 요청
          }, { scope: 'public_profile' })
        }
      })
    },
    appleLogin () {
      this.setReferer()
      AppleID.auth.init({
        clientId: 'kr.co.captv.pooqV2.member',
        scope: 'email',
        redirectURI: 'https://member.wavve.com/mobile/signup/mweb/apple',
        state: '',
        usePopup: false // or false defaults to false
      })
      AppleID.auth.signIn()
    },
    loginProc ({ type, id, password = '' }) {
      return UserService.login({
        type,
        id,
        pushid: 'none',
        password,
        profile: '0',
        credential: ''
      }, (error) => {
        if (error.response.status === 551 &&
          error.response.data.resultcode === this.signupResultCode) {
          window.location.href = error.response.data.resultoptional
        } else {
          alert('아이디 또는 비밀번호를 확인해 주세요.')
        }
      }).then((response) => {
        const loginInfo = get(response, 'data', null)
        const credential = get(loginInfo, 'credential', '')
        if (loginInfo && credential !== '') {
          PartnersService.checkAlreadyRegisted(credential).then(({ data }) => {
            const { resultcode, resultmessage } = data
            if (resultcode === '550') {
              alert(resultmessage)
            } else {
              if (get(data, 'alreadyauth', 'n').toUpperCase() === 'Y') {
                if (confirm('이미 이메일 인증을 완료하셨습니다.\n이용권 페이지로 이동합니다.')) {
                  utils.cookies.setItem('cs', JSON.stringify(loginInfo), null, URL_COOKIE_DOMAIN, '/')
                  this.$router.replace({ name: PATH_NAME_VOUCHER, query: { promotioncode: 'forholder' } })
                } else {
                  location.replace(location.protocol + location.hostname)
                }
              } else {
                if (confirm('이 페이지는 관계사 전용 페이지로, 이메일 인증이 필요합니다.\n이메일 인증을 진행해 주세요.')) {
                  utils.cookies.setItem('cs', JSON.stringify(loginInfo), null, URL_COOKIE_DOMAIN, '/')
                  this.$router.replace({ name: 'initEmail' })
                } else {
                  location.replace(location.protocol + location.hostname)
                }
              }
            }
          })
        }
      })
    },
    togglePasswordInputType () {
      this.hidePassword = !this.hidePassword
    },
    naverLibInit () {
      const self = this
      window.loginResponse = function () {
        self.naverLoginLib.getLoginStatus((status) => {
          if (status) {
            const accessToken = get(self.naverLoginLib, 'accessToken.accessToken', false)
            if (accessToken) {
              self.loginProc({
                type: 'naver',
                id: accessToken
              })
            }
          }
        })
      }
      let loadingInterval = setInterval(() => {
        if (window.naver) {
          // window.naver 로드 완료 되면 Interval 취소
          clearInterval(loadingInterval)
          // LoginWithNaverId 선언
          this.naverLoginLib = new naver.LoginWithNaverId(
            {
              clientId: 'IMRF4m29ielhnUTZYGHL', // 개발자센터에 등록한 ClientID
              // 개발자센터에 등록한 callback Url
              callbackUrl: window.location.protocol + '//pp.wavve.com/member/login_naver.html',
              isPopup: true, // 팝업을 통한 연동처리 여부
              callbackHandle: true, // callback 페이지 핸들링 여부
              loginButton: { color: 'green', type: 1, height: 60 } // 로그인 버튼의 타입을 지정
            }
          )
          // 설정정보를 초기화하고 연동 준비
          this.naverLoginLib.init()
        }
      }, 200)
      setLibFile(document, 'script', 'naver-jssdk', '//static.nid.naver.com/js/naveridlogin_js_sdk_2.0.0.js')
    },
    kakaoLibInit () {
      window.kakaoAsyncInit = function () {
        Kakao.init('30fc7e17b5c56a0ca1e861643292c203')
      }
      setLibFile(document, 'script', 'kakao-jssdk', '//developers.kakao.com/sdk/js/kakao.min.js')
    },
    facebookLibInit () {
      window.fbAsyncInit = function () {
        FB.init({
          appId: '1818575348440201',
          status: true,
          cookie: true, // 쿠키가 세션을 참조할 수 있도록 허용
          xfbml: true, // 소셜 플러그인이 있으면 처리
          version: 'v4.0' // 버전 4.0 사용
        })
      }
      setLibFile(document, 'script', 'facebook-jssdk', '//connect.facebook.net/ko_KR/sdk.js')
    },
    appleLibInit () {
      setLibFile(document, 'script', 'apple-login', '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/ko_KR/appleid.auth.js')
    }
  },
  computed: {
    isSupportBrowser () {
      return !isIE()
    }
  },
  created () {
    if (!this.isSupportBrowser) {
      alert('인터넷 익스플로러(IE)에서는 이용하실 수 없습니다.\nChrome, Firefox, Edge 브라우저로 이용해 주세요')
    } else {
      const externalType = get(this.$route, 'query.type', '')
      const idToken = get(this.$route, 'query.id_token', '')
      if (externalType !== '' && idToken !== '') {
        if (externalType === 'tid') {
          this.tLoginProc(idToken)
        }
        if (externalType === 'apple') {
          this.appleLoginProc(idToken)
        }
      } else {
        this.kakaoLibInit()
        this.naverLibInit()
        this.facebookLibInit()
        this.appleLibInit()
      }
    }
    // pp-wavve-token 처리
  }
}
</script>
<style scoped>
  .noti-purple,
  .noti-red {
    padding: 6px 0 12px;
    font-size: 0;
  }
  .noti-purple {
    color: #ff27a3;
  }
  .noti-purple > span{
    display: inline-block;
    vertical-align: middle;
  }
  .join-noti-ico {
    font-size: 0;
  }
  .join-noti-text {
    margin-left: 4px;
    font-size: 12px;
    line-height: 18px;
    color: #ff27a3;
  }
</style>
